export const EMPLOYEE_TICKET = "EMPLOYEE_TICKET";
export const EMPLOYEE_TICKET_DETAILS = "EMPLOYEE_TICKET_DETAILS";
export const EMPLOYEE_STATUS = "EMPLOYEE_STATUS";
export const EMPLOYEE_FILTER = "EMPLOYEE_FILTER";
